let resizeTimeout;

const handleEqualHeight = () => {
	const $trigger = $('.js-equal-height');

	$trigger.each(function() {
		const $this = $(this);
		const row = $this.data('row');
		const $currentRow = $('.js-equal-height[data-row="' + row + '"]');
		let minHeight = 0;

		$currentRow.each(function(index, el) {
			const $this = $(this);

			$this.css('min-height', 0);

			minHeight = $this.outerHeight();
		});

		$currentRow.css('min-height', minHeight);
	});
}

$(window).on('load', function() {
	handleEqualHeight();
}).on('resize', function() {
	if ( resizeTimeout ) clearTimeout(resizeTimeout);

	resizeTimeout = setTimeout(function(){
		handleEqualHeight();
	}, 500);
});
